module.exports = __webpack_public_path__ + "img/mobile/SmartButton/btn-autop-up@3x.png?0.0.53";